import React, {useState} from "react";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import DeleteIcon from "@mui/icons-material/Delete";
import ListItemText from "@mui/material/ListItemText";
import CancelIcon from "@mui/icons-material/Cancel";
import {useBookingDelete, useBookingCancel} from "../query";
import {useNavigate} from "react-router-dom";


const BookingActionMenu = function (props) {
    const {booking} = props
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const bookingDelete = useBookingDelete({bookingId: booking?.id});
    const bookingCancel = useBookingCancel();

    const {askConfirmation, showSuccessNotification, showErrorNotification} = useFeedbackTools();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        const innerDelete = async () => {
            try {
                await bookingDelete.mutateAsync();
                showSuccessNotification("Prenotazione eliminata correttamente");
                navigate('/main/bookings?tab=tableau');
            } catch (e) {
                showErrorNotification(e);
            }
        }

        handleClose();
        askConfirmation({
            title: "Elimina prenotazione",
            description: "Confermi di voler eliminare la prenotazione?",
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: innerDelete
        });
    }

    const handleCancel = () => {
        const innerCancel = async () => {
            try {
                await bookingCancel.mutateAsync({id: booking.id});
                showSuccessNotification("La prenotazione è stata disdetta");
                navigate('/main/bookings?tab=tableau');
            } catch (e) {
                showErrorNotification(e);
            }
        }

        handleClose();
        askConfirmation({
            title: "Disdici prenotazione",
            description: "Confermi di voler disdire la prenotazione?",
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: innerCancel
        });
    }

    return (
        <Box sx={{color: "inherit"}}>
            <IconButton
                aria-controls="booking-action-menu"
                aria-haspopup="true"
                edge="end"
                aria-label="comments"
                onClick={handleClick}
                sx={{color: "inherit"}}>
                <MoreVertIcon sx={{color: "inherit"}}/>
            </IconButton>

            <Menu
                id="booking-action-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}>

                <MenuItem onClick={handleDelete} disabled={!booking?.isDeleteAllowed()}>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Elimina prenotazione</ListItemText>
                </MenuItem>

                <MenuItem onClick={handleCancel}>
                    <ListItemIcon>
                        <CancelIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Disdici prenotazione</ListItemText>
                </MenuItem>
            </Menu>
        </Box>
    );
};


export default BookingActionMenu;